import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InHospitalListFilter } from '../store/user-graph/user-graph.reducer';
import { UserSearchedPatient } from '../types/aggregate-graph.types';

@Injectable({
	providedIn: 'root'
})
export class CurrentUserService {

	constructor(private httpClient: HttpClient) {
	}

	pingServer() {
		return this.httpClient.get('/api/current-user/ping-server');
	}

	putSelectedTeam(teamId: string) {
		return this.httpClient.put<string>(`/api/current-user/selected-teams/${teamId}`, null);
	}

	deleteSelectedTeam(teamId: string) {
		return this.httpClient.delete(`/api/current-user/selected-teams/${teamId}`);
	}

	putSearchedPatient(patient: UserSearchedPatient) {
		return this.httpClient.put<string>(`/api/current-user/searched-patients/${patient.patientId}`, patient);
	}

	setLoginPin(pin: string) {
		return this.httpClient.put<void>('/api/current-user/pin', JSON.stringify(pin), { headers: { 'Content-Type': 'application/json' } });
	}

	setInHospitalListFilters(filters: InHospitalListFilter[]) {
		return this.httpClient.put<void>('/api/current-user/in-hospital-list-filters', JSON.stringify(JSON.stringify(filters)), { headers: { 'Content-Type': 'application/json' } });
	}
}